module.exports = __webpack_public_path__ + "static/media/icon_play.62e9dec3.svg";